import React, { useState } from 'react';

import { createChatService } from '../../services/chatService';
import AIChatQuotaProvider from './AIChatQuotaProvider';

type TeacherToolsQuotaProviderProps = {
  children: React.ReactNode;
  shouldReadOnMount?: boolean;
};

/** The teacher's quota on the screens that have no chat service of their own. */
function TeacherToolsQuotaProvider({ children, shouldReadOnMount = true }: TeacherToolsQuotaProviderProps): JSX.Element {
  // Created once: a new instance on each render would re-read the quota every time.
  const [chatService] = useState(() => createChatService());

  return (
    <AIChatQuotaProvider chatService={chatService} shouldReadOnMount={shouldReadOnMount}>
      {children}
    </AIChatQuotaProvider>
  );
}

export default TeacherToolsQuotaProvider;
